import createHistory from 'history/createBrowserHistory';

import api from 'utils/api';
import { gettext } from 'utils/text';
import { buildUrl } from 'utils/urls';

const history = createHistory();

const LOAD_ITEMS = 'mentors/LOAD_ITEMS';
const SET_FILTER_KEY = 'mentors/SET_FILTER_KEY';
const SET_FILTERS = 'mentors/SET_FILTERS';
const SET_URL_HANDLING = 'mentors/SET_URL_HANDLING';

const initialState = {
    items: {},
    itemIds: [],
    limit: 6,
    choices: [{ key: 'all', filter: {}, label: 'All' }],
    filters: {},
    filterKey: 'all',
    hasMore: true,
    startLoad: true,
    query: '',
    // Some places across trafo, get parameters are used for various stuff, so can't really change the URL
    // without harm done, thus adding an option to skip this
    handleUrl: true,
};

export default function mentorsReducer(state = initialState, action) {
    switch (action.type) {
        case LOAD_ITEMS: {
            const normalizedItems = {};
            const itemIds = action.clear ? [] : [...state.itemIds];

            action.items.forEach((item) => {
                normalizedItems[item.id] = item;

                if (!itemIds.includes(item.id)) {
                    itemIds.push(item.id);
                }
            });

            const items = action.clear ? normalizedItems : { ...state.items, ...normalizedItems };

            return {
                ...state,
                hasMore: action.count > itemIds.length,
                items,
                itemIds,
                startLoad: false,
            };
        }

        case SET_FILTER_KEY: {
            return {
                ...state,
                filterKey: action.filterKey,
                startLoad: true,
            };
        }

        case SET_FILTERS: {
            return {
                ...state,
                ...action.filters,
            };
        }

        case SET_URL_HANDLING: {
            return {
                ...state,
                handleUrl: action.handle,
            };
        }

        default: {
            return state;
        }
    }
}

const setItems = (items, count, clear) => ({ type: LOAD_ITEMS, items, count, clear });

const makeUrl = (state) => {
    const { filterKey, query } = state;

    const baseUrl = window.location.pathname;

    // Query parameters to be added to the URL.
    // The keys are parameter names, values are parameter values.
    const queryParams = {
        filter: filterKey,
        query,
    };

    return buildUrl(baseUrl, queryParams);
};

export const loadItems = (clear = false) => (dispatch, getState) => {
    const state = getState();
    const { itemIds, limit, filterKey, choices, handleUrl } = state;

    const activeFilters = choices.find((filter) => filter.key === filterKey);

    const queryParams = {
        offset: clear ? 0 : itemIds.length,
        limit,
    };

    if (activeFilters.key !== 'all') {
        queryParams.codename = activeFilters.key;
    }

    api.mentors.fetch(null, queryParams).then((result) => {
        dispatch(setItems(result.results, result.count, clear));
        if (handleUrl) {
            const url = makeUrl(state);
            history.replace(url);
        }
    });
};

export const setFilterKey = (filterKey) => (dispatch) => {
    dispatch({ type: SET_FILTER_KEY, filterKey });
    dispatch(loadItems(true));
};

/* Used to initially set filters when the app loads form URL with filters prefilled */
export const setFilters = (filters) => (dispatch) => {
    dispatch({ type: SET_FILTERS, filters });
    dispatch(loadItems(true));
};

export const setUrlHandling = (handle) => (dispatch) => {
    dispatch({ type: SET_URL_HANDLING, handle });
};



// WEBPACK FOOTER //
// ./src/ducks/mentorlist.js